/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState} from 'react';

// material
import {
    Group,
    Control,
} from '@insticator/insticator-ui'; // iui-material

// redux
import {useDispatch, useSelector} from "react-redux";

// components
import SectionGroupDescription
    from "../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription";
import SectionGroup from "../../../../../material/expandablesection/sectiongroup/sectiongroup";

// styles
import injectSheet from 'react-jss';
import styles from './formatsettings_styles';

// static
import {
    FORMAT,
    FORMAT_OPTIONS,
    SCHEDULE
} from "../consts";
import {updateReportForm} from "../../../../../state/slices/report";


/* ========== ~~~~~~~~~~ FREQUENCY FORM ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => {
    const formValues = useSelector((state) => state.report[props.uuid]);
    // Report type decides CSV-only (SSP) vs full formats.
    const isSspReport = formValues?.reportProductType === 'SSP';

    const dispatch = useDispatch();

    const handleOnChange = newValues => {
        dispatch(updateReportForm({...formValues, ...newValues}));
    }

    const handleFormatChange = val => {
        let scheduleSettings = {...formValues[SCHEDULE]}
        scheduleSettings[FORMAT] = val
        handleOnChange({[SCHEDULE]: scheduleSettings})
    }

    // If this is an SSP report with XLSX selected, force it to CSV
    useEffect(() => {
        if (isSspReport && formValues && formValues[SCHEDULE] && formValues[SCHEDULE][FORMAT] === 'XLSX') {
            handleFormatChange('CSV');
        }
    }, [isSspReport, formValues?.[SCHEDULE]?.[FORMAT]]);

    const formatOptions = isSspReport
        ? FORMAT_OPTIONS.filter(o => o.value !== 'XLSX')
        : FORMAT_OPTIONS;

    return (
        <div className={props.classes.formatSettings}>
            <SectionGroup>
                <SectionGroupDescription
                    title='Format'
                    description={isSspReport ? 'Excel format is not available for SSP reports due to large data sizes.' : ''}
                />
                <Group name='format'>
                    {formatOptions.map(i => <Control
                        key={i.value}
                        text={i.title}
                        value={i.value}
                        selected={i.value === formValues[SCHEDULE][FORMAT]}
                        handleSelect={handleFormatChange}
                        variant={'secondary'}
                        addCheckWhenSelected={true}
                    />)}
                </Group>
            </SectionGroup>
        </div>
    )
});

